<template>
  <div id="app">
    <router-view />
    <script type="application/javascript" src="assets/js/bootstrap.bundle.min.js"></script>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    let loaders = document.getElementsByClassName("loading-screen");
    if (loaders.length > 0) {
      loaders[0].style.zIndex = 30000000;
    }
  },
};
</script>

<style>
@import './assets/css/bootstrap-customer.css';
@import './assets/css/bootstrap.min.css';
@import './assets/css/bootstrap.css';
@import './assets/css/bootstrap-icons.css';
@import './assets/css/style.css';


@import '~vue-multiselect/dist/vue-multiselect.min.css';

.filepond--root .filepond--credits {
  display: none !important;
}

a {
  text-decoration: none !important;
}

</style>
